import React, { Suspense, useEffect, useMemo } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import styled, { StyleSheetManager } from "styled-components";
import Loading from "components/common/Loading";
import WS from "util/ws";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { MixContractTokenInfo } from "store/entity";
import { MixContractAllTokensSelector } from "store/data/Token";
import { MediaScreenMobile } from "components/common/styled";
import rtlPlugin from "stylis-plugin-rtl";
import useDirection from "hooks/useDirection";
import { Dir } from "constants/vars";
import { checkIsApp } from "util/DeviceInfo";
// import { checkIsApp } from '@bit/js-bridge'
import loadable from "@app/utils/loadable";
// import ComplianceBar from "@shark/micro-components/react/ComplianceBar";
// import "@shark/micro-components/react/ComplianceBar.css";
import CommonSEO from "seo/CommonSEO";
import { App as AppWrapper, message } from "@bit-design/react";
import { useKoaContext } from "@app/utils/KoaContext";
import { containsChineseOrEmoji } from "util/safe";
import NotFound from "components/common/NotFound";
import {
  LoginSelector,
  UserSimulationFlagState,
  UserState,
} from "../store/data/User";
import Cookies from "js-cookie";
import Header from "container/Header";

// const Header = loadable(() => import("container/Header"), {
//   ssr: false,
//   loading: false,
// });
const ImportNotice = loadable(() => import("components/ImportNotice"), {
  ssr: false,
  loading: false,
});
// const ImportNoticeNew = loadable(() => import("components/ImportNoticeNew"), {
//   ssr: false,
//   loading: false,
// });
const GlobalDialog = loadable(() => import("components/GlobalDialog"), {
  ssr: false,
  loading: false,
});

const TradeNotice = loadable(() => import("components/TradeNotice"), {
  ssr: false,
  loading: false,
});

const ModifyOrderNotice = loadable(
  () =>
    import(
      "components/ContractOrderNew/CurrentOrder/modify/notification/Notice"
    ),
  {
    ssr: false,
    loading: false,
  }
);

const PriceNotice = loadable(
  () =>
    import("components/Drawers/PriceAlert/components/PriceNoticeGlobal/index"),
  {
    ssr: false,
    loading: false,
  }
);

const GlobalConfig = loadable(() => import("container/GlobalConfig"), {
  ssr: false,
  loading: false,
});

// const FuturesDemoAccountContainer = loadable(
//   () => import("./FuturesDemoAccountContainer"),
//   {
//     ssr: false,
//     loading: false,
//   }
// );

const MainContainerWrapper = styled.div<{ limitedWidth: boolean }>`
  width: 100%;
  box-sizing: border-box;
  ${({ limitedWidth }) => limitedWidth && "min-width: 1400px;"}
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  background: var(--background-primary);

  .body-wrapper {
    flex: 1;
  }

  // 适配移动端
  ${MediaScreenMobile(`
        min-width: 100vw;
    `)}
`;

// 通知框整体逻辑 end；

const App: React.FC = () => {
  const setMixAllToken = useSetRecoilState(MixContractAllTokensSelector);
  const { pathname } = useLocation();
  const { locales } = useParams();
  const isUK = locales === "en-GB";
  const isLogin = useRecoilValue(LoginSelector);
  const userInfo = useRecoilValue(UserState);
  const ctx = useKoaContext();
  const isSimulationTrade = useRecoilValue(UserSimulationFlagState);
  message.config({
    top: 160,
  });
  useEffect(() => {
    const ws = WS.getInstance();

    ws.registerEventListener("open", () => {
      ws.subscribe<MixContractTokenInfo[]>("marginPrice", {}, (data) => {
        setMixAllToken(data.data);
      });
    });
    // eslint-disable-next-line
  }, []);

  const { direction } = useDirection();
  const stylisPlugins = direction === Dir.RTL ? [rtlPlugin] : [];

  const showKycNotice =
    !isSimulationTrade &&
    Boolean(isLogin && (userInfo?.areaId == "" || userInfo?.areaId == null));

  const limitedWidth = useMemo(() => {
    return !new RegExp(
      `(${["/trading-bot", "/trading-bot/detail/(spot|futures)/[0-9]+", "/futures", "/futures/"].join("|")})$`
    ).test(pathname);
  }, [pathname]);

  return (
    <AppWrapper>
      <StyleSheetManager stylisPlugins={stylisPlugins}>
        <MainContainerWrapper limitedWidth={limitedWidth}>
          <CommonSEO />
          <Header />
          {containsChineseOrEmoji(ctx?.request?.url || pathname) ? (
            <NotFound />
          ) : (
            <>
              <ImportNotice />
              <Suspense fallback={<Loading isShowText={true} />}>
                <Outlet />
                <GlobalConfig />
                <TradeNotice />
                <PriceNotice />
                <ModifyOrderNotice />
                <GlobalDialog />
                {/* <FuturesDemoAccountContainer /> */}
              </Suspense>
            </>
          )}
        </MainContainerWrapper>
      </StyleSheetManager>
    </AppWrapper>
  );
};

export default React.memo(App);
